// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-site-footer----styles-module---container---6D6fJ","wrapped":"src-components-site-footer----styles-module---wrapped---FqlV9","inner":"src-components-site-footer----styles-module---inner---1HHq-","logos":"src-components-site-footer----styles-module---logos---Z3ZVq","bottom":"src-components-site-footer----styles-module---bottom---23PW2","links":"src-components-site-footer----styles-module---links---1pN5w","copy":"src-components-site-footer----styles-module---copy---J9Q37"};


//////////////////
// WEBPACK FOOTER
// ./src/components/site-footer/styles.module.css
// module id = 634
// module chunks = 168707334958949